export default __webpack_public_path__ + "static/media/pp-icon-active.25616388.svg";